export default __webpack_public_path__ + "static/media/arpan_patel-monadinfotech.7507130a.png";